import { render, staticRenderFns } from "./CohortsPage.vue?vue&type=template&id=ad646e90"
import script from "./CohortsPage.vue?vue&type=script&lang=js"
export * from "./CohortsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports